/**
 * Modelos dos objetos de configurações dos gráficos
 */
export function getDefaultChartConfigDataPayload() {
  return {
    chartsColors: {},
    fontsSizes: 14,
    colorSchemeValue: 'standard',
  };
}
